import { Group } from '@/components/_common';
import { ReportQuotationCompany } from '@/core/domain/stock/Quotations/Quotations.types';
import { Row, Col, Typography, Image } from 'antd';
import moment from 'moment';

interface Props {
  company: ReportQuotationCompany;
  title: string;
}

const date = moment();

const ReportQuotationsHeader: React.FC<Props> = ({ company, title }) => {
  return (
    <div className="card">
      <Row align="middle">
        <Col flex={1} className="reportQuotation-header-info">
          <Group gap={24}>
            {!!company.logo && <Image src={company.logo} width={80} />}
            <div>
              <Typography.Title level={3} className="m-0 p-0">
                {company.name}
              </Typography.Title>
              <Typography.Title level={4} className="m-0 p-0">
                {title}
              </Typography.Title>
            </div>
          </Group>
        </Col>

        <Col span={6} className="reportQuotation-header-date">
          <big>
            <Row align="middle">
              <Col span={10} className="text-right">
                <strong>Emissão:</strong>
              </Col>
              <Col span={14} className="text-right">
                <span>{date.format('DD/MM/YYYY')}</span>
              </Col>
            </Row>
            <Row align="middle">
              <Col span={10} className="text-right">
                <strong>Horário:</strong>
              </Col>
              <Col span={14} className="text-right">
                <span>{date.format('HH:mm:ss')}</span>
              </Col>
            </Row>
          </big>
        </Col>
      </Row>
    </div>
  );
};

export default ReportQuotationsHeader;
